export var isStop = function isStop(event) {
  return event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
};
export var hasName = function hasName(event) {
  for (var _len = arguments.length, names = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    names[_key - 1] = arguments[_key];
  }
  return names.includes(event.name);
};